export class ColumnContainerConfig {
    public static maxColumnWidth: number = 12;
    public static minColumnWidth: number = 0;
}
